import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import {
  getFtaKeysDefaultText,
  getRsaSummaryDefaultText,
} from '../default-text';
import { defaultValues } from '../../../components/default-values';
import { FormSchema } from '../../../components/form-schema';

export const clientDefaultValues = (
  campaignName: string,
  visitMetrics: Lci3Report['visitMetrics'],
  salesSummary: Lci3Report['salesMetrics'] | null
): FormSchema => {
  return {
    ...defaultValues,
    campaignName,
    ftaSummary: getFtaKeysDefaultText(visitMetrics, campaignName),
    rsaSummary: salesSummary
      ? getRsaSummaryDefaultText(visitMetrics, salesSummary, campaignName)
      : '',
    ftaOverallResults: getFtaKeysDefaultText(visitMetrics, campaignName),
    rsaOverallResults: salesSummary
      ? getRsaSummaryDefaultText(visitMetrics, salesSummary, campaignName)
      : '',
  };
};
